<template>
    <div class="container">
        <div class="filter_path">
            <el-form :inline="true" :model="params" class="form-inline">
                <el-form-item>
                    <el-input class="filter_input" v-model="params.keyword" placeholder="加工单号" size="mini"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input class="filter_input" v-model="params.keyword" placeholder="加工日期" size="mini"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.keyword" placeholder="状态" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.keyword" placeholder="加工类型" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.keyword" placeholder="加工厂" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-link type="danger" :underline="false">重置</el-link>
                    <el-button type="danger" size="mini">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="operate_row">
            <div class="">
                <el-button type="danger" size="customize" @click="dialogVisible = true">新建加工单</el-button>
                <el-button plain size="customize">费用项目</el-button>
                <el-button plain size="customize">删除</el-button>
            </div>
        </div>
        <div class="table_path">
            <el-table :data="list" style="width: 100%" border height="100%" size="mini" header-cell-class-name="list_table_th">
                <el-table-column type="index"></el-table-column>
                <el-table-column type="selection"></el-table-column>
                <el-table-column label="操作"></el-table-column>
                <el-table-column label="加工日期"></el-table-column>
                <el-table-column label="加工单号"></el-table-column>
                <el-table-column label="状态"></el-table-column>
                <el-table-column label="批次号"></el-table-column>
                <el-table-column label="原木方数"></el-table-column>
                <el-table-column label="原木根数"></el-table-column>
                <el-table-column label="湿材方数"></el-table-column>
                <el-table-column label="干材方数"></el-table-column>
                <el-table-column label="加工厂"></el-table-column>
                <el-table-column label="加工费(合计)"></el-table-column>
                <el-table-column label="加工类型"></el-table-column>
                <el-table-column label="成材率"></el-table-column>
                <el-table-column label="制单人"></el-table-column>
            </el-table>
        </div>
        <div class="pagination_path">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="current_page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <el-dialog v-dialog-drag title="" :visible.sync="dialogVisible" width="1318px" >
            <div class="" slot="title">
                <div class="dialog_title">东阳木业加工单</div>
            </div>
            <div class="">
                <el-form :inline="true" :model="params" class="dialog_form" size="mini">
                    <el-form-item label="加工单号：">
                        <el-input class="dialog_input" v-model="params.keyword" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="加工日期：">
                        <el-input class="dialog_input" v-model="params.keyword" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="加工厂：">
                        <el-select class="dialog_input" v-model="params.keyword" placeholder="">
                            <el-option value="1">123</el-option>
                            <el-option value="2">123</el-option>
                            <el-option value="3">123</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="加工费：">
                        <el-select class="dialog_input" v-model="params.keyword" placeholder="">
                            <el-option value="1">123</el-option>
                            <el-option value="2">123</el-option>
                            <el-option value="3">123</el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="dialog_path">
                    <div class="title">加工需求</div>
                    <el-table :data="list1" :span-method="objectSpanMethod" style="width: 100%" border height="150px" size="mini" header-cell-class-name="list_table_th">
                        <el-table-column type="index"></el-table-column>
                        <el-table-column type="selection"></el-table-column>
                        <el-table-column label="操作"></el-table-column>
                        <el-table-column label="长度(m)" prop="length"></el-table-column>
                        <el-table-column label="厚度(cm)" prop="height"></el-table-column>
                        <el-table-column label="单条备注" prop="sremark"></el-table-column>
                        <el-table-column label="备注" width="510" prop="remark"></el-table-column>
                    </el-table>
                </div>
                <div class="dialog_path">
                    <div class="title">
                        原料明细
                        <el-link type="danger" :underline="false">从原木库存选择</el-link>
                    </div>
                    <el-table :data="list1" style="width: 100%" border height="287px" size="mini" header-cell-class-name="list_table_th">
                        <el-table-column type="index"></el-table-column>
                        <el-table-column type="selection"></el-table-column>
                        <el-table-column label="操作"></el-table-column>
                        <el-table-column label="树种"></el-table-column>
                        <el-table-column label="船名"></el-table-column>
                        <el-table-column label="批次号"></el-table-column>
                        <el-table-column label="堆号"></el-table-column>
                        <el-table-column label="长度（m）"></el-table-column>
                        <el-table-column label="直径（m）"></el-table-column>
                        <el-table-column label="根数"></el-table-column>
                        <el-table-column label="码单立方"></el-table-column>
                        <el-table-column label="备注"></el-table-column>
                    </el-table>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="customize" plain @click="dialogVisible = false">取消</el-button>
                <el-button size="customize" type="danger" @click="dialogVisible = false">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        .filter_path{
            padding: 15px; background-color: #F4F5F9;
            .form-inline{
                & > div{
                    margin-right: 30px;
                    button { margin-left: 25px; }
                }
            }
            .filter_input{
                width: 120px;
                & + .filter_input{ margin-left: 34px; }
            }
        }
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 28px 0 8px;
        }
        .table_path{ flex: 1; }

        // dialog START
        .dialog_title{ font-size: 24px; color: #333333; text-align: center; }
        .dialog_form{
            background: #F4F5F8; padding: 20px 15px;
            & > div{ margin: 0;  margin-right: 60px; }
            .dialog_input{ width: 120px; }
        }
        .dialog_path {
            .title{ display: flex; align-items: center; justify-content: space-between; font-size:16px; color: #333333; font-weight:bold; line-height:22px; padding: 18px 0 7px; }
        }
    }
</style>
<script>
    import pagination from '../../components/pagination.vue'
    export default {
        components:{
            pagination,
        },
        data(){
            return{
                params:{
                    keyword: "",
                    belong: "",
                    project: "",
                    per_page: 20
                },
                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],
                // dialog START
                dialogVisible : false,
                id : 0,
                list1 : [
                    {
                        length : 1,
                        height : 1,
                        sremark : 1,
                        remark : 1,
                    },
                    {
                        length : 1,
                        height : 1,
                        sremark : 1,
                        remark : 1,
                    },
                    {
                        length : 1,
                        height : 1,
                        sremark : 1,
                        remark : 1,
                    },
                    {
                        length : 1,
                        height : 1,
                        sremark : 1,
                        remark : 1,
                    },
                ]
                // dialog END
            }
        },
        methods:{
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            objectSpanMethod({   rowIndex, columnIndex }) {

                if (columnIndex === 6) {
                    if (rowIndex == 0) {
                        return {
                            rowspan: this.list1.length,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            }
        },
    }
</script>
